define('uikit/helper/dom',['require','exports','module','jquery'],function(require, exports, module){
  var $ = require('jquery');

  /**
   * Returns a function to set the caret position
   * @params {Boolean} atStart      Flag whether to set caret at the start or end of the element
   */
  function createCaretPlacer(atStart) {
    return function(el) {
        el.focus();
        if (typeof window.getSelection != "undefined"
                && typeof document.createRange != "undefined") {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(atStart);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange != "undefined") {
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(atStart);
            textRange.select();
        }
    };
  }

  var DOM = {

    /**
     * Given an element, sets the caret to the beginning of the text node
     */
    placeCaretAtStart: createCaretPlacer(true),

    /**
     * Given an element, sets the caret to the end of the text node
     */
    placeCaretAtEnd: createCaretPlacer(false),

    /**
     * Clear the current document selections
     */
    clearSelection: function() {
      var selection = window.getSelection();

      if (selection.rangeCount > 0) {
        selection.getRangeAt(0).startContainer.parentNode.blur();
      }

      selection.removeAllRanges();
    },

    /**
     * Returns information on the cursor position
     * @return {Object}  Returns the caret start and end indices and the number of characters selected
     *
     * Only applicable when text nodes are selected
     */
    cursorPosition: function() {
      var selection  = document.getSelection(),
          caretRange = {};

      if (selection.rangeCount > 0) {
        caretRange = selection.getRangeAt(0);
      }

      return {
        caretStart      : caretRange.startOffset,
        caretEnd        : caretRange.endOffset,
        selectionLength : caretRange.endOffset - caretRange.startOffset
      }
    },

    /**
     * Return all the focusable elements
     * @params {DOM Element} parentEl    Specific dom element to look within
     * @return {JQuery Object}           Return the jquery object containing all the possible focusable elements
     */
    focusable: function(parentEl) {
      var parent = $(parentEl || document.body);
      return parent.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]')
              .filter(':visible')
              .filter(function(index, el) {
                return $(el).css('visibility') == 'visible';
              })
    },

    /**
     * Only allow tabbing within the indicated element,
     * if tab on the last element, focus the first element,
     * if shift+tab on the first element, focus the last element
     * 
     * Use with keydown event
     */
    stickFocusWithinElement: function(ev, container) {
      var target = ev.target,
          focusableChildren = null,
          focusableNumOfChildren = null;

      if (ev.keyCode == 9) {
        focusableChildren = this.focusable(container);
        focusableNumOfChildren = focusableChildren.length;

        // Assuming always at least one focusable element within the modal (ex. close btn)
        // otherwise, don't proceed
         if (!focusableNumOfChildren) {
          target.blur();
          ev.preventDefault();
          return;
        }

        // If user presses shift+tab
        if (ev.shiftKey) {
          // And current focused element is the first child element or not contained within the modal
          if (focusableChildren.get(0) == target || !container.contains(target)) {
            ev.preventDefault();

            // Focus the last focusable child
            focusableChildren.eq(focusableNumOfChildren-1).focus();
          }
        // If user presses tab
        } else {
          // And current focused element is the last child element or not contained within the modal
          if (focusableChildren.get(focusableNumOfChildren-1) == target || !container.contains(target)) {
            ev.preventDefault();

            // Focus the first focusable child
            focusableChildren.eq(0).focus();
          }
        }
      }
    }

  };

  module.exports = DOM;

});
